import React from 'react'

import styled from 'styled-components'

const EmptyWrapper = ({
  children,
  maxHeight = '100px',
  marginBottom = '0',
  marginTop = '0',
}) => {
  return (
    <StyledEmptyWrapper
      maxHeight={maxHeight}
      marginBottom={marginBottom}
      marginTop={marginTop}
    >
      {children}
    </StyledEmptyWrapper>
  )
}

const StyledEmptyWrapper = styled.div`
  height: 100%;
  max-height: ${({ maxHeight }) => maxHeight};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  margin-top: ${({ marginTop }) => marginTop};
  min-height: 100px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 300;
  border-radius: 3px;
  border: 1px solid rgb(238, 238, 246);
  box-sizing: border-box;
  box-shadow: rgba(178, 178, 203, 0.2) 3px 3px 7px;
`

export default EmptyWrapper
